import React from 'react';
import { Col } from 'reactstrap';
import Select from 'react-select';
import { Spin } from 'antd';
import './css/SelectFieldFlags.css';

const SelectFieldWithFlags = ({
  label,
  name,
  formik,
  isLoading,
  options = [],
  error,
  colSize,
  nameSelect,
  onChange,
}) => {
  const customOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className="fc-select-option"
      >
        {data.flag && (
          <img
            src={data.flag}
            alt={data.label}
            className="fc-flag-icon"
          />
        )}
        <span>{data.label}</span>
      </div>
    );
  };

  const customSingleValue = ({ data, innerRef, innerProps }) => (
    <div
      ref={innerRef}
      {...innerProps}
      className="fc-select-single-value"
    >
      {data.flag && (
        <img
          src={data.flag}
          alt={data.label}
          className="fc-flag-icon"
        />
      )}
      <span>{data.label}</span>
    </div>
  );

  const customStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
  }),
  singleValue: (provided) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    gap: '0px',
    margin: '0px',
    padding: '0px',
    lineHeight: '1',
    height: '100%',
  }),
  input: (provided) => ({
    ...provided,
    minHeight: '8px',
    height: '8px',
    margin: 0,
    padding: 0,
    lineHeight: '1',
  }),
  option: (provided, state) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    backgroundColor: state.isSelected
      ? '#f0f0f0'
      : state.isFocused
      ? '#fafafa'
      : 'white',
    color: 'black',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};


  return (
    <Col lg={colSize}>
      <div className="mb-3">
        <label htmlFor={name} className="form-label label">
          {label}
        </label>
        {isLoading ? (
          <div className="fc-react-select-loading">
            <Spin size="small" />
          </div>
        ) : (
          <Select
            id={name}
            name={name}
            options={options}
            value={options.find((opt) => opt.value === formik.values[name]) || null}
            onChange={(selectedOption) => {
              formik.setFieldValue(name, selectedOption?.value);
              if (onChange) onChange(selectedOption);
            }}
            onBlur={() => formik.setFieldTouched(name, true)}
            placeholder={`Choisir ${nameSelect}`}
            components={{
              SingleValue: customSingleValue,
              Option: customOption,
            }}
            styles={customStyles}
          />
        )}
        {formik.touched[name] && error && (
          <div className="text-danger mt-1">{error}</div>
        )}
      </div>
    </Col>
  );
};

export default SelectFieldWithFlags;
